module.exports = __webpack_public_path__ + "static/media/marg-brochure.e8690c77.pdf";